import { ANY_EMPLOYEE_ID } from '@/features/booking-selection/constants';
import { PlaceEmployee } from '@/types/state/shared';

export type UrlEmployeeResolution = {
  /** The employee whose `about.externalId` matches `sr`, when one exists. */
  matched: PlaceEmployee | undefined;
  /** True when `sr` carries the any-employee sentinel ("valfri utövare") rather than an externalId. */
  isAnyEmployee: boolean;
};

/**
 * The single definition of the `sr` precedence rule, shared by `deriveStepSelection` (guards)
 * and `useBookingFlowSelection` (hydration) so the two can never disagree (a disagreement is
 * a redirect loop). externalId lookup first, sentinel second: an employee whose externalId is
 * literally '0' wins over the any-employee sentinel.
 */
export function resolveEmployeeFromUrl(
  sr: string | undefined,
  employees: PlaceEmployee[] | undefined,
): UrlEmployeeResolution {
  const matched = sr ? (employees ?? []).find((employee) => employee.about?.externalId === sr) : undefined;
  return {
    matched,
    isAnyEmployee: !matched && sr === String(ANY_EMPLOYEE_ID),
  };
}
